"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcologicalSurvey = void 0;
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var SpaceBonus_1 = require("../../SpaceBonus");
var TileType_1 = require("../../TileType");
var Resources_1 = require("../../Resources");
var ResourceType_1 = require("../../ResourceType");
var AddResourcesToCard_1 = require("../../deferredActions/AddResourcesToCard");
var GainResources_1 = require("../../deferredActions/GainResources");
var Phase_1 = require("../../Phase");
var Tags_1 = require("../Tags");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var BoardType_1 = require("../../boards/BoardType");
var EcologicalSurvey = (function (_super) {
    __extends(EcologicalSurvey, _super);
    function EcologicalSurvey() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.ECOLOGICAL_SURVEY,
            tags: [Tags_1.Tags.SCIENCE],
            cost: 9,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.greeneries(3).any(); }),
            metadata: {
                description: 'Requires 3 greeneries on Mars.',
                cardNumber: 'A07',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When placing a tile grants you any plants, animals or microbes, you gain one additional of each of those resources that you gain.', function (eb) {
                        eb.emptyTile().startEffect;
                        eb.plus().plants(1).animals(1).microbes(1);
                    });
                }),
            },
        }) || this;
    }
    EcologicalSurvey.prototype.anyAdjacentSpaceGivesBonus = function (player, space, bonus) {
        return player.game.board.getAdjacentSpaces(space).some(function (adj) { var _a; return (_a = adj.adjacency) === null || _a === void 0 ? void 0 : _a.bonus.includes(bonus); });
    };
    EcologicalSurvey.prototype.onTilePlaced = function (cardOwner, activePlayer, space, boardType) {
        var _this = this;
        var _a;
        if (boardType !== BoardType_1.BoardType.MARS) {
            return;
        }
        if (cardOwner.game.phase === Phase_1.Phase.SOLAR || cardOwner.id !== activePlayer.id) {
            return;
        }
        if (space.bonus.includes(SpaceBonus_1.SpaceBonus.PLANT) ||
            this.anyAdjacentSpaceGivesBonus(cardOwner, space, SpaceBonus_1.SpaceBonus.PLANT) ||
            (((_a = space.tile) === null || _a === void 0 ? void 0 : _a.tileType) === TileType_1.TileType.OCEAN && cardOwner.playedCards.some(function (card) { return card.name === CardName_1.CardName.ARCTIC_ALGAE; }))) {
            cardOwner.game.defer(new GainResources_1.GainResources(cardOwner, Resources_1.Resources.PLANTS, {
                cb: function () { return activePlayer.game.log('${0} gained a bonus ${1} because of ${2}', function (b) { return b.player(cardOwner).string(Resources_1.Resources.PLANTS).cardName(_this.name); }); },
            }));
        }
        [[ResourceType_1.ResourceType.MICROBE, SpaceBonus_1.SpaceBonus.MICROBE], [ResourceType_1.ResourceType.ANIMAL, SpaceBonus_1.SpaceBonus.ANIMAL]].forEach(function (_a) {
            var resource = _a[0], bonus = _a[1];
            if (cardOwner.playedCards.some(function (card) { return card.resourceType === resource; }) &&
                (space.bonus.includes(bonus) || _this.anyAdjacentSpaceGivesBonus(cardOwner, space, bonus))) {
                cardOwner.game.defer(new AddResourcesToCard_1.AddResourcesToCard(cardOwner, resource, {
                    logMessage: '${0} gained a bonus ${1} because of ${2}',
                    logBuilder: function (b) { return b.player(cardOwner).string(resource).cardName(_this.name); },
                }));
            }
        });
    };
    EcologicalSurvey.prototype.play = function () {
        return undefined;
    };
    return EcologicalSurvey;
}(Card_1.Card));
exports.EcologicalSurvey = EcologicalSurvey;
//# sourceMappingURL=EcologicalSurvey.js.map